// extracted by mini-css-extract-plugin
export var aircallIframe = "_fk-3";
export var fabContainer = "_fk-5";
export var fabRinging = "_fk-6";
export var loadingOverlay = "_fk-4";
export var pulse = "_fk-7";
export var widgetContent = "_fk-2";
export var widgetPanel = "_fk-0";
export var widgetPanelExpanded = "_fk-1";